import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DataService } from '../data-services/data.service';
import { IMember } from './../../models/member';
import {
  ISaleCampaign,
  ISaleCampaignDetail,
} from './../../models/sale-campaign';
import { ITransaction } from './../../models/transaction';

@Injectable({
  providedIn: 'root',
})
export class SaleCampaignService extends DataService<ISaleCampaign> {
  getAllActiveDues(organizationId: string): Observable<ISaleCampaign[]> {
    const url = `${this.urlService.buildUrl(
      this.collectionname
    )}organization/${organizationId}/dues`;

    return this.http.get<ISaleCampaign[]>(`${url}`).pipe(
      map((res: any) => {
        if (Array.isArray(res)) {
          res.forEach((item) => {
            this.setId(item);
          });
        }
        return res || [];
      }),
      catchError(this.errorMgmt)
    );
  }

  getCampaignOrders(
    campaignId: string,
    organizationId: string
  ): Observable<ITransaction[]> {
    const url = `${this.urlService.buildUrl(
      this.collectionname
    )}organization/${organizationId}/campaignId/${campaignId}/orders`;

    return this.http.get<ITransaction[]>(`${url}`, {}).pipe(
      map((res: any) => {
        res.forEach((item) => {
          this.setId(item);
        });
        return res || ({} as any);
      }),
      catchError(this.errorMgmt)
    );
  }

  campaignsByType(
    organizationId: string,
    type: string
  ): Observable<ISaleCampaign[]> {
    const url = `${this.urlService.buildUrl(
      this.collectionname,
      'campaigns',
      `${type}/type`
    )}`;

    return this.http.get<Array<ISaleCampaign[]>>(`${url}`).pipe(
      map((res: any) => {
        this.setId(res);
        return res || ({} as any);
      }),
      catchError(this.errorMgmt)
    );
  }

  submitCampaignOrder(
    transaction: ITransaction,
    user: IMember
  ): Observable<any> {
    const url = `${this.urlService.buildUrl(this.collectionname)}organization/${
      transaction.organizationId
    }/campaignId/${transaction.attributes['campaignId']}/pay`;

    return this.http.post<ITransaction>(`${url}`, { transaction, user }).pipe(
      map((res: any) => {
        this.setId(res);
        return res || ({} as any);
      }),
      catchError(this.errorMgmt)
    );
  }
  // termList$ = new BehaviorSubject<ITerm[]>([]);

  getCampaignDetail(
    organizationId: string,
    campaignId: string
  ): Observable<ISaleCampaignDetail> {
    const url = `${this.urlService.buildUrl(
      this.collectionname
    )}organization/${organizationId}/campaignId/${campaignId}/read`;

    return this.http.get<Array<ISaleCampaignDetail>>(`${url}`).pipe(
      map((res: any) => {
        this.setId(res);
        this.setId(res.products);
        this.setId(res.localProducts);
        return res || ({} as any);
      }),
      catchError(this.errorMgmt)
    );
  }

  getCampaignDetailBySaleCode(saleCode: string): Observable<ISaleCampaign> {
    const url = `${this.urlService.buildUrl(
      this.collectionname
    )}${saleCode}/sale-code`;

    return this.http.get<Array<ISaleCampaign>>(`${url}`).pipe(
      map((res: any) => {
        this.setId(res);
        return res || ({} as any);
      }),
      catchError(this.errorMgmt)
    );
  }

  getUnmatchedPayments(organizationId: string, status = 'unmatched'): Observable<any[]> {
    const url = `${this.urlService.buildUrl(
      this.collectionname
    )}organization/${organizationId}/unmatched-payments?status=${status}`;

    return this.http.get<any[]>(url).pipe(
      map((res: any) => res || []),
      catchError(this.errorMgmt)
    );
  }

  resolveUnmatchedPayment(id: string, userId: string, note?: string): Observable<any> {
    const url = `${this.urlService.buildUrl(
      this.collectionname
    )}unmatched-payments/${id}/resolve`;

    return this.http.patch<any>(url, { userId, note }).pipe(
      map((res: any) => res || {}),
      catchError(this.errorMgmt)
    );
  }

  ignoreUnmatchedPayment(id: string, note?: string): Observable<any> {
    const url = `${this.urlService.buildUrl(
      this.collectionname
    )}unmatched-payments/${id}/ignore`;

    return this.http.patch<any>(url, { note }).pipe(
      map((res: any) => res || {}),
      catchError(this.errorMgmt)
    );
  }

  protected collectionname = 'sale';
}
